module.exports = __webpack_public_path__ + "static/media/charity.04ac0b6c.jpg";